"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[7065],{

/***/ 37065:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "t": function() { return /* binding */ Pagination; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@mantine/styles/esm/theme/MantineProvider.js + 25 modules
var MantineProvider = __webpack_require__(3241);
// EXTERNAL MODULE: ./node_modules/@mantine/styles/esm/theme/utils/get-size/get-size.js
var get_size = __webpack_require__(14258);
// EXTERNAL MODULE: ./node_modules/@mantine/hooks/esm/use-uncontrolled/use-uncontrolled.js
var use_uncontrolled = __webpack_require__(15851);
;// CONCATENATED MODULE: ./node_modules/@mantine/hooks/esm/utils/range/range.js
function range(start, end) {
  const length = end - start + 1;
  return Array.from({ length }, (_, index) => index + start);
}


//# sourceMappingURL=range.js.map

;// CONCATENATED MODULE: ./node_modules/@mantine/hooks/esm/use-pagination/use-pagination.js




const DOTS = "dots";
function usePagination({
  total,
  siblings = 1,
  boundaries = 1,
  page,
  initialPage = 1,
  onChange
}) {
  const _total = Math.max(Math.trunc(total), 0);
  const [activePage, setActivePage] = (0,use_uncontrolled/* useUncontrolled */.C)({
    value: page,
    onChange,
    defaultValue: initialPage,
    finalValue: initialPage
  });
  const setPage = (pageNumber) => {
    if (pageNumber <= 0) {
      setActivePage(1);
    } else if (pageNumber > _total) {
      setActivePage(_total);
    } else {
      setActivePage(pageNumber);
    }
  };
  const next = () => setPage(activePage + 1);
  const previous = () => setPage(activePage - 1);
  const first = () => setPage(1);
  const last = () => setPage(_total);
  const paginationRange = (0,react.useMemo)(() => {
    const totalPageNumbers = siblings * 2 + 3 + boundaries * 2;
    if (totalPageNumbers >= _total) {
      return range(1, _total);
    }
    const leftSiblingIndex = Math.max(activePage - siblings, boundaries);
    const rightSiblingIndex = Math.min(activePage + siblings, _total - boundaries);
    const shouldShowLeftDots = leftSiblingIndex > boundaries + 2;
    const shouldShowRightDots = rightSiblingIndex < _total - (boundaries + 1);
    if (!shouldShowLeftDots && shouldShowRightDots) {
      const leftItemCount = siblings * 2 + boundaries + 2;
      return [...range(1, leftItemCount), DOTS, ...range(_total - (boundaries - 1), _total)];
    }
    if (shouldShowLeftDots && !shouldShowRightDots) {
      const rightItemCount = boundaries + 1 + 2 * siblings;
      return [...range(1, boundaries), DOTS, ...range(_total - rightItemCount, _total)];
    }
    return [
      ...range(1, boundaries),
      DOTS,
      ...range(leftSiblingIndex, rightSiblingIndex),
      DOTS,
      ...range(_total - boundaries + 1, _total)
    ];
  }, [_total, siblings, activePage]);
  return {
    range: paginationRange,
    active: activePage,
    setPage,
    next,
    previous,
    first,
    last
  };
}


//# sourceMappingURL=use-pagination.js.map

// EXTERNAL MODULE: ./node_modules/@mantine/utils/esm/create-event-handler/create-event-handler.js
var create_event_handler = __webpack_require__(69328);
// EXTERNAL MODULE: ./node_modules/@mantine/utils/esm/create-safe-context/create-safe-context.js
var create_safe_context = __webpack_require__(68216);
;// CONCATENATED MODULE: ./node_modules/@mantine/core/esm/Pagination/Pagination.context.js


const [PaginationProvider, usePaginationContext] = (0,create_safe_context/* createSafeContext */.R)("Pagination.Root component was not found in tree");


//# sourceMappingURL=Pagination.context.js.map

;// CONCATENATED MODULE: ./node_modules/@mantine/core/esm/Pagination/PaginationRoot/PaginationRoot.js






const defaultProps = {
  siblings: 1,
  boundaries: 1
};
function PaginationRoot(props) {
  const {
    total,
    value,
    defaultValue,
    onChange,
    disabled,
    children,
    siblings,
    boundaries,
    color,
    radius,
    onNextPage,
    onPreviousPage,
    onFirstPage,
    onLastPage,
    getItemProps,
    classNames,
    styles,
    unstyled,
    variant,
    size
  } = (0,MantineProvider/* useComponentDefaultProps */.N4)("PaginationRoot", defaultProps, props);
  const { range, setPage, next, previous, active, first, last } = usePagination({
    page: value,
    initialPage: defaultValue,
    onChange,
    total,
    siblings,
    boundaries
  });
  const handleNextPage = (0,create_event_handler/* createEventHandler */.x)(onNextPage, next);
  const handlePreviousPage = (0,create_event_handler/* createEventHandler */.x)(onPreviousPage, previous);
  const handleFirstPage = (0,create_event_handler/* createEventHandler */.x)(onFirstPage, first);
  const handleLastPage = (0,create_event_handler/* createEventHandler */.x)(onLastPage, last);
  return /* @__PURE__ */ react.createElement(PaginationProvider, {
    value: {
      total,
      range,
      active,
      disabled,
      color,
      radius,
      getItemProps,
      onChange: setPage,
      onNext: handleNextPage,
      onPrevious: handlePreviousPage,
      onFirst: handleFirstPage,
      onLast: handleLastPage,
      stylesApi: {
        name: "Pagination",
        classNames,
        styles,
        unstyled,
        variant,
        size
      }
    }
  }, children);
}


//# sourceMappingURL=PaginationRoot.js.map

// EXTERNAL MODULE: ./node_modules/@mantine/styles/esm/theme/utils/rem/rem.js
var rem = __webpack_require__(96768);
// EXTERNAL MODULE: ./node_modules/@mantine/styles/esm/tss/create-styles.js + 1 modules
var create_styles = __webpack_require__(56817);
;// CONCATENATED MODULE: ./node_modules/@mantine/core/esm/Pagination/PaginationControl/PaginationControl.styles.js


const sizes = {
  xs: (0,rem/* rem */.h)(22),
  sm: (0,rem/* rem */.h)(26),
  md: (0,rem/* rem */.h)(32),
  lg: (0,rem/* rem */.h)(38),
  xl: (0,rem/* rem */.h)(44)
};
var useStyles = (0,create_styles/* createStyles */.k)((theme, { color, radius, withPadding }, { size }) => {
  const colors = theme.fn.variant({ color, variant: "filled" });
  return {
    control: {
      cursor: "pointer",
      userSelect: "none",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      border: `${(0,rem/* rem */.h)(1)} solid ${theme.colorScheme === "dark" ? theme.colors.dark[4] : theme.colors.gray[4]}`,
      color: theme.colorScheme === "dark" ? theme.colors.dark[0] : theme.black,
      height: (0,get_size/* getSize */.a)({ size, sizes }),
      minWidth: (0,get_size/* getSize */.a)({ size, sizes }),
      padding: withPadding ? `0 calc(${(0,get_size/* getSize */.a)({ size, sizes: theme.spacing })} / 2)` : void 0,
      fontSize: (0,get_size/* getSize */.a)({ size, sizes: theme.fontSizes }),
      borderRadius: theme.fn.radius(radius),
      lineHeight: 1,
      backgroundColor: theme.colorScheme === "dark" ? theme.colors.dark[6] : theme.white,
      "&:not([data-disabled])": theme.fn.hover({
        backgroundColor: theme.colorScheme === "dark" ? theme.colors.dark[5] : theme.colors.gray[0]
      }),
      "&:active:not([data-disabled])": theme.activeStyles,
      "&[data-disabled]": {
        opacity: 0.4,
        cursor: "not-allowed"
      },
      "&[data-active]": {
        borderColor: "transparent",
        color: colors.color,
        backgroundColor: colors.background,
        "&:not([data-disabled])": theme.fn.hover({
          backgroundColor: colors.hover
        })
      }
    }
  };
});

/* harmony default export */ var PaginationControl_styles = (useStyles);

//# sourceMappingURL=PaginationControl.styles.js.map

// EXTERNAL MODULE: ./node_modules/@mantine/core/esm/UnstyledButton/UnstyledButton.js + 1 modules
var UnstyledButton = __webpack_require__(34736);
;// CONCATENATED MODULE: ./node_modules/@mantine/core/esm/Pagination/PaginationControl/PaginationControl.js






var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const PaginationControl_defaultProps = {
  withPadding: true
};
const PaginationControl = (0,react.forwardRef)((props, ref) => {
  const _a = (0,MantineProvider/* useComponentDefaultProps */.N4)("PaginationControl", PaginationControl_defaultProps, props), { active, className, disabled, withPadding } = _a, others = __objRest(_a, ["active", "className", "disabled", "withPadding"]);
  const ctx = usePaginationContext();
  const { classes, cx } = PaginationControl_styles({ color: ctx.color, radius: ctx.radius, withPadding }, ctx.stylesApi);
  return /* @__PURE__ */ react.createElement(UnstyledButton/* UnstyledButton */.k, __spreadProps(__spreadValues({}, others), {
    disabled,
    "data-active": active || void 0,
    "data-disabled": disabled || void 0,
    ref,
    className: cx(classes.control, className)
  }));
});
PaginationControl.displayName = "@mantine/core/PaginationControl";


//# sourceMappingURL=PaginationControl.js.map

;// CONCATENATED MODULE: ./node_modules/@mantine/core/esm/Pagination/Pagination.icons.js




var Pagination_icons_defProp = Object.defineProperty;
var Pagination_icons_defProps = Object.defineProperties;
var Pagination_icons_getOwnPropDescs = Object.getOwnPropertyDescriptors;
var Pagination_icons_getOwnPropSymbols = Object.getOwnPropertySymbols;
var Pagination_icons_hasOwnProp = Object.prototype.hasOwnProperty;
var Pagination_icons_propIsEnum = Object.prototype.propertyIsEnumerable;
var Pagination_icons_defNormalProp = (obj, key, value) => key in obj ? Pagination_icons_defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var Pagination_icons_spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (Pagination_icons_hasOwnProp.call(b, prop))
      Pagination_icons_defNormalProp(a, prop, b[prop]);
  if (Pagination_icons_getOwnPropSymbols)
    for (var prop of Pagination_icons_getOwnPropSymbols(b)) {
      if (Pagination_icons_propIsEnum.call(b, prop))
        Pagination_icons_defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var Pagination_icons_spreadProps = (a, b) => Pagination_icons_defProps(a, Pagination_icons_getOwnPropDescs(b));
var Pagination_icons_objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (Pagination_icons_hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && Pagination_icons_getOwnPropSymbols)
    for (var prop of Pagination_icons_getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && Pagination_icons_propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
function getIconSize(size) {
  return `calc(${(0,get_size/* getSize */.a)({ size, sizes: sizes })} / 2)`;
}
function PaginationIcon(_a) {
  var _b = _a, { size, children, path } = _b, others = Pagination_icons_objRest(_b, ["size", "children", "path"]);
  return /* @__PURE__ */ react.createElement("svg", Pagination_icons_spreadValues({
    width: size,
    height: size,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg"
  }, others), /* @__PURE__ */ react.createElement("path", {
    d: path,
    fill: "currentColor"
  }));
}
const PaginationNextIcon = (props) => /* @__PURE__ */ react.createElement(PaginationIcon, Pagination_icons_spreadProps(Pagination_icons_spreadValues({}, props), {
  path: "M8.781 8l-3.3-3.3.943-.943L10.667 8l-4.243 4.243-.943-.943 3.3-3.3z"
}));
const PaginationPreviousIcon = (props) => /* @__PURE__ */ react.createElement(PaginationIcon, Pagination_icons_spreadProps(Pagination_icons_spreadValues({}, props), {
  path: "M7.219 8l3.3 3.3-.943.943L5.333 8l4.243-4.243.943.943-3.3 3.3z"
}));
const PaginationFirstIcon = (props) => /* @__PURE__ */ react.createElement(PaginationIcon, Pagination_icons_spreadProps(Pagination_icons_spreadValues({}, props), {
  path: "M6.85355 3.85355C7.04882 3.65829 7.04882 3.34171 6.85355 3.14645C6.65829 2.95118 6.34171 2.95118 6.14645 3.14645L2.14645 7.14645C1.95118 7.34171 1.95118 7.65829 2.14645 7.85355L6.14645 11.8536C6.34171 12.0488 6.65829 12.0488 6.85355 11.8536C7.04882 11.6583 7.04882 11.3417 6.85355 11.1464L3.20711 7.5L6.85355 3.85355ZM12.8536 3.85355C13.0488 3.65829 13.0488 3.34171 12.8536 3.14645C12.6583 2.95118 12.3417 2.95118 12.1464 3.14645L8.14645 7.14645C7.95118 7.34171 7.95118 7.65829 8.14645 7.85355L12.1464 11.8536C12.3417 12.0488 12.6583 12.0488 12.8536 11.8536C13.0488 11.6583 13.0488 11.3417 12.8536 11.1464L9.20711 7.5L12.8536 3.85355Z"
}));
const PaginationLastIcon = (props) => /* @__PURE__ */ react.createElement(PaginationIcon, Pagination_icons_spreadProps(Pagination_icons_spreadValues({}, props), {
  path: "M2.14645 11.1464C1.95118 11.3417 1.95118 11.6583 2.14645 11.8536C2.34171 12.0488 2.65829 12.0488 2.85355 11.8536L6.85355 7.85355C7.04882 7.65829 7.04882 7.34171 6.85355 7.14645L2.85355 3.14645C2.65829 2.95118 2.34171 2.95118 2.14645 3.14645C1.95118 3.34171 1.95118 3.65829 2.14645 3.85355L5.79289 7.5L2.14645 11.1464ZM8.14645 11.1464C7.95118 11.3417 7.95118 11.6583 8.14645 11.8536C8.34171 12.0488 8.65829 12.0488 8.85355 11.8536L12.8536 7.85355C13.0488 7.65829 13.0488 7.34171 12.8536 7.14645L8.85355 3.14645C8.65829 2.95118 8.34171 2.95118 8.14645 3.14645C7.95118 3.34171 7.95118 3.65829 8.14645 3.85355L11.7929 7.5L8.14645 11.1464Z"
}));
const PaginationDotsIcon = (props) => /* @__PURE__ */ react.createElement(PaginationIcon, Pagination_icons_spreadProps(Pagination_icons_spreadValues({}, props), {
  path: "M2 8c0-.733.6-1.333 1.333-1.333.734 0 1.334.6 1.334 1.333s-.6 1.333-1.334 1.333C2.6 9.333 2 8.733 2 8zm9.333 0c0-.733.6-1.333 1.334-1.333C13.4 6.667 14 7.267 14 8s-.6 1.333-1.333 1.333c-.734 0-1.334-.6-1.334-1.333zM6.667 8c0-.733.6-1.333 1.333-1.333s1.333.6 1.333 1.333S8.733 9.333 8 9.333 6.667 8.733 6.667 8z"
}));


//# sourceMappingURL=Pagination.icons.js.map

;// CONCATENATED MODULE: ./node_modules/@mantine/core/esm/Pagination/PaginationDots/PaginationDots.styles.js



var PaginationDots_styles_useStyles = (0,create_styles/* createStyles */.k)((theme, _params, { size }) => ({
  dots: {
    height: (0,get_size/* getSize */.a)({ size, sizes: sizes }),
    minWidth: (0,get_size/* getSize */.a)({ size, sizes: sizes }),
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    pointerEvents: "none"
  }
}));

/* harmony default export */ var PaginationDots_styles = (PaginationDots_styles_useStyles);
//# sourceMappingURL=PaginationDots.styles.js.map

// EXTERNAL MODULE: ./node_modules/@mantine/core/esm/Box/Box.js + 9 modules
var Box = __webpack_require__(7414);
;// CONCATENATED MODULE: ./node_modules/@mantine/core/esm/Pagination/PaginationDots/PaginationDots.js







var PaginationDots_defProp = Object.defineProperty;
var PaginationDots_getOwnPropSymbols = Object.getOwnPropertySymbols;
var PaginationDots_hasOwnProp = Object.prototype.hasOwnProperty;
var PaginationDots_propIsEnum = Object.prototype.propertyIsEnumerable;
var PaginationDots_defNormalProp = (obj, key, value) => key in obj ? PaginationDots_defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var PaginationDots_spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (PaginationDots_hasOwnProp.call(b, prop))
      PaginationDots_defNormalProp(a, prop, b[prop]);
  if (PaginationDots_getOwnPropSymbols)
    for (var prop of PaginationDots_getOwnPropSymbols(b)) {
      if (PaginationDots_propIsEnum.call(b, prop))
        PaginationDots_defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var PaginationDots_objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (PaginationDots_hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && PaginationDots_getOwnPropSymbols)
    for (var prop of PaginationDots_getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && PaginationDots_propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const PaginationDots_defaultProps = {
  icon: PaginationDotsIcon
};
const PaginationDots = (0,react.forwardRef)((props, ref) => {
  const _a = (0,MantineProvider/* useComponentDefaultProps */.N4)("PaginationDots", PaginationDots_defaultProps, props), {
    className,
    icon: Icon
  } = _a, others = PaginationDots_objRest(_a, [
    "className",
    "icon"
  ]);
  const ctx = usePaginationContext();
  const { classes, cx } = PaginationDots_styles(null, ctx.stylesApi);
  return /* @__PURE__ */ react.createElement(Box/* Box */.x, PaginationDots_spreadValues({
    ref,
    className: cx(classes.dots, className)
  }, others), /* @__PURE__ */ react.createElement(Icon, {
    size: getIconSize(ctx.stylesApi.size)
  }));
});
PaginationDots.displayName = "@mantine/core/PaginationDots";


//# sourceMappingURL=PaginationDots.js.map

;// CONCATENATED MODULE: ./node_modules/@mantine/core/esm/Pagination/PaginationItems/PaginationItems.js





var PaginationItems_defProp = Object.defineProperty;
var PaginationItems_getOwnPropSymbols = Object.getOwnPropertySymbols;
var PaginationItems_hasOwnProp = Object.prototype.hasOwnProperty;
var PaginationItems_propIsEnum = Object.prototype.propertyIsEnumerable;
var PaginationItems_defNormalProp = (obj, key, value) => key in obj ? PaginationItems_defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var PaginationItems_spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (PaginationItems_hasOwnProp.call(b, prop))
      PaginationItems_defNormalProp(a, prop, b[prop]);
  if (PaginationItems_getOwnPropSymbols)
    for (var prop of PaginationItems_getOwnPropSymbols(b)) {
      if (PaginationItems_propIsEnum.call(b, prop))
        PaginationItems_defNormalProp(a, prop, b[prop]);
    }
  return a;
};
function PaginationItems({ dotsIcon }) {
  const ctx = usePaginationContext();
  const items = ctx.range.map((page, index) => {
    var _a;
    if (page === "dots") {
      return /* @__PURE__ */ react.createElement(PaginationDots, {
        icon: dotsIcon,
        key: index
      });
    }
    return /* @__PURE__ */ react.createElement(PaginationControl, PaginationItems_spreadValues({
      key: index,
      active: page === ctx.active,
      "aria-current": page === ctx.active ? "page" : void 0,
      onClick: () => ctx.onChange(page),
      disabled: ctx.disabled
    }, (_a = ctx.getItemProps) == null ? void 0 : _a.call(ctx, page)), page);
  });
  return /* @__PURE__ */ react.createElement(react.Fragment, null, items);
}
PaginationItems.displayName = "@mantine/core/PaginationItems";


//# sourceMappingURL=PaginationItems.js.map

// EXTERNAL MODULE: ./node_modules/@mantine/utils/esm/create-polymorphic-component/create-polymorphic-component.js
var create_polymorphic_component = __webpack_require__(48427);
;// CONCATENATED MODULE: ./node_modules/@mantine/core/esm/Pagination/PaginationEdges/PaginationEdges.styles.js


var PaginationEdges_styles_useStyles = (0,create_styles/* createStyles */.k)((theme) => ({
  icon: {
    transform: theme.dir === "rtl" ? "rotate(180deg)" : "unset"
  }
}));

/* harmony default export */ var PaginationEdges_styles = (PaginationEdges_styles_useStyles);
//# sourceMappingURL=PaginationEdges.styles.js.map

;// CONCATENATED MODULE: ./node_modules/@mantine/core/esm/Pagination/PaginationEdges/PaginationEdges.js








var PaginationEdges_defProp = Object.defineProperty;
var PaginationEdges_getOwnPropSymbols = Object.getOwnPropertySymbols;
var PaginationEdges_hasOwnProp = Object.prototype.hasOwnProperty;
var PaginationEdges_propIsEnum = Object.prototype.propertyIsEnumerable;
var PaginationEdges_defNormalProp = (obj, key, value) => key in obj ? PaginationEdges_defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var PaginationEdges_spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (PaginationEdges_hasOwnProp.call(b, prop))
      PaginationEdges_defNormalProp(a, prop, b[prop]);
  if (PaginationEdges_getOwnPropSymbols)
    for (var prop of PaginationEdges_getOwnPropSymbols(b)) {
      if (PaginationEdges_propIsEnum.call(b, prop))
        PaginationEdges_defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var PaginationEdges_objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (PaginationEdges_hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && PaginationEdges_getOwnPropSymbols)
    for (var prop of PaginationEdges_getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && PaginationEdges_propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
function createEdgeComponent({ icon, name, action, type }) {
  const defaultProps = { icon };
  const Component = (0,react.forwardRef)((props, ref) => {
    const _a = (0,MantineProvider/* useComponentDefaultProps */.N4)(name, defaultProps, props), { icon: Icon } = _a, others = PaginationEdges_objRest(_a, ["icon"]);
    const { classes } = PaginationEdges_styles();
    const ctx = usePaginationContext();
    const disabled = type === "next" ? ctx.active === ctx.total : ctx.active === 1;
    return /* @__PURE__ */ react.createElement(PaginationControl, PaginationEdges_spreadValues({
      disabled: ctx.disabled || disabled,
      ref,
      onClick: ctx[action],
      withPadding: false
    }, others), /* @__PURE__ */ react.createElement(Icon, {
      className: classes.icon,
      size: getIconSize(ctx.stylesApi.size)
    }));
  });
  Component.displayName = `@mantine/core/${name}`;
  return (0,create_polymorphic_component/* createPolymorphicComponent */.F)(Component);
}
const PaginationNext = createEdgeComponent({
  icon: PaginationNextIcon,
  name: "PaginationNext",
  action: "onNext",
  type: "next"
});
const PaginationPrevious = createEdgeComponent({
  icon: PaginationPreviousIcon,
  name: "PaginationPrevious",
  action: "onPrevious",
  type: "previous"
});
const PaginationFirst = createEdgeComponent({
  icon: PaginationFirstIcon,
  name: "PaginationFirst",
  action: "onFirst",
  type: "previous"
});
const PaginationLast = createEdgeComponent({
  icon: PaginationLastIcon,
  name: "PaginationLast",
  action: "onLast",
  type: "next"
});


//# sourceMappingURL=PaginationEdges.js.map

// EXTERNAL MODULE: ./node_modules/@mantine/core/esm/Group/Group.js + 1 modules
var Group = __webpack_require__(71232);
;// CONCATENATED MODULE: ./node_modules/@mantine/core/esm/Pagination/Pagination.js









var Pagination_defProp = Object.defineProperty;
var Pagination_getOwnPropSymbols = Object.getOwnPropertySymbols;
var Pagination_hasOwnProp = Object.prototype.hasOwnProperty;
var Pagination_propIsEnum = Object.prototype.propertyIsEnumerable;
var Pagination_defNormalProp = (obj, key, value) => key in obj ? Pagination_defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var Pagination_spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (Pagination_hasOwnProp.call(b, prop))
      Pagination_defNormalProp(a, prop, b[prop]);
  if (Pagination_getOwnPropSymbols)
    for (var prop of Pagination_getOwnPropSymbols(b)) {
      if (Pagination_propIsEnum.call(b, prop))
        Pagination_defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var Pagination_objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (Pagination_hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && Pagination_getOwnPropSymbols)
    for (var prop of Pagination_getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && Pagination_propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const Pagination_defaultProps = {
  withControls: true,
  siblings: 1,
  boundaries: 1
};
function Pagination(props) {
  const _a = (0,MantineProvider/* useComponentDefaultProps */.N4)("Pagination", Pagination_defaultProps, props), {
    withEdges,
    withControls,
    classNames,
    styles,
    unstyled,
    variant,
    size,
    total,
    value,
    defaultValue,
    onChange,
    disabled,
    siblings,
    boundaries,
    color,
    radius,
    onNextPage,
    onPreviousPage,
    onFirstPage,
    onLastPage,
    getItemProps,
    getControlProps,
    spacing,
    nextIcon,
    previousIcon,
    lastIcon,
    firstIcon,
    dotsIcon
  } = _a, others = Pagination_objRest(_a, [
    "withEdges",
    "withControls",
    "classNames",
    "styles",
    "unstyled",
    "variant",
    "size",
    "total",
    "value",
    "defaultValue",
    "onChange",
    "disabled",
    "siblings",
    "boundaries",
    "color",
    "radius",
    "onNextPage",
    "onPreviousPage",
    "onFirstPage",
    "onLastPage",
    "getItemProps",
    "getControlProps",
    "spacing",
    "nextIcon",
    "previousIcon",
    "lastIcon",
    "firstIcon",
    "dotsIcon"
  ]);
  const theme = (0,MantineProvider/* useMantineTheme */.rZ)();
  if (total <= 0) {
    return null;
  }
  return /* @__PURE__ */ react.createElement(PaginationRoot, {
    classNames,
    styles,
    unstyled,
    variant,
    size,
    total,
    value,
    defaultValue,
    onChange,
    disabled,
    siblings,
    boundaries,
    color,
    radius,
    onNextPage,
    onPreviousPage,
    onFirstPage,
    onLastPage,
    getItemProps
  }, /* @__PURE__ */ react.createElement(Group/* Group */.Z, Pagination_spreadValues({
    spacing: spacing != null ? spacing : `calc(${(0,get_size/* getSize */.a)({ size, sizes: theme.spacing })} / 2)`
  }, others), withEdges && /* @__PURE__ */ react.createElement(PaginationFirst, Pagination_spreadValues({
    icon: firstIcon
  }, getControlProps == null ? void 0 : getControlProps("first"))), withControls && /* @__PURE__ */ react.createElement(PaginationPrevious, Pagination_spreadValues({
    icon: previousIcon
  }, getControlProps == null ? void 0 : getControlProps("previous"))), /* @__PURE__ */ react.createElement(PaginationItems, {
    dotsIcon
  }), withControls && /* @__PURE__ */ react.createElement(PaginationNext, Pagination_spreadValues({
    icon: nextIcon
  }, getControlProps == null ? void 0 : getControlProps("next"))), withEdges && /* @__PURE__ */ react.createElement(PaginationLast, Pagination_spreadValues({
    icon: lastIcon
  }, getControlProps == null ? void 0 : getControlProps("last")))));
}
Pagination.displayName = "@mantine/core/Pagination";
Pagination.Root = PaginationRoot;
Pagination.Items = PaginationItems;
Pagination.Control = PaginationControl;
Pagination.Dots = PaginationDots;
Pagination.Next = PaginationNext;
Pagination.Previous = PaginationPrevious;
Pagination.Last = PaginationLast;
Pagination.First = PaginationFirst;


//# sourceMappingURL=Pagination.js.map


/***/ })

}]);